import PromoPage from './PromoPage';
export default PromoPage;